import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Badge, Tooltip } from "antd";
import { formatDistanceStrict } from "date-fns";
import ptBrLocale from "date-fns/locale/pt-BR";

interface CardTitleInterface {
  id: Number;
  onClick?: any;
  title: string;
  errors: string[];
  saleDate: string;
}

function CardTitle({
  id,
  title,
  saleDate,
  errors,
  onClick,
}: CardTitleInterface) {
  return errors?.length ? (
    <Tooltip
      title={errors.map((error) => (
        <div>
          {error}
          <br />
        </div>
      ))}
      color={"red"}
      arrow={false}
    >
      <Badge
        count={
          <ExclamationCircleOutlined
            style={{ color: "#f5222d", fontSize: 16 }}
          />
        }
        title="Atrasado"
      >
        <div
          onClick={() => onClick(id)}
          className="cursor-pointer hover:opacity-75 "
        >
          <div className="w-56 text-[#74889c] leading-5">{title}</div>
          <div className="font-bold italic text-xs text-sky-400 float-right ">
            {formatDistanceStrict(new Date(), new Date(saleDate), {
              locale: ptBrLocale,
              unit: "day",
            })}
          </div>
        </div>
      </Badge>
    </Tooltip>
  ) : (
    <div
      onClick={() => onClick(id)}
      className="cursor-pointer hover:opacity-75 "
    >
      <div className="w-56 ">{title}</div>
      <div className="font-bold italic text-xs text-sky-400 float-right ">
        {formatDistanceStrict(new Date(), new Date(saleDate), {
          locale: ptBrLocale,
          unit: "day",
        })}
      </div>
    </div>
  );
}

export default CardTitle;
